<template>
    <div class="row">
      <div class="col-lg-12">
         <block-cntr
          btitle="IGMP Snooping Global Config"
          style="height: 410px"
        >
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="editSelectRow"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th
                  v-for="(value, key) in igmpSnoopTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in igmpSnoopTable.data" :key="index">
                <td
                  v-for="(value, key) in row"
                  :key="key"
                  :title="value"
                >
                  <div>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr> 

        <div v-if="isShowAddTable">
          <dialog-box
            btitle="IGMP Snooping Global Edit"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
            <div class="form-group">
              <label class="col-sm-3 control-label" for="igmpswitch"
                >IGMP Snooping</label
              >
              <div class="col-sm-5">
                <select class="form-control" id="igmpswitch" v-model="igmpSnoopEnable">
                  <option value="2">Disable</option>
                  <option value="1">Enable</option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-3 control-label" for="reportsuppression">Report-suppression</label>
              <div class="col-sm-5">
                <select class="form-control" id="reportsuppression" v-model="reportSuppression">
                  <option value="0">Disable</option>
                  <option value="1">Enable</option>
                </select>
              </div>
            </div>
            <!--
            <div class="form-group">
              <label class="col-sm-3 control-label" for="router">Router-port-forward</label>
              <div class="col-sm-5">
                <select class="form-control" id="router" v-model="routerPortEnable">
                  <option value="2">Disable</option>
                  <option value="1">Enable</option>
                </select>
              </div>
            </div>
            -->

            <div class="form-group">
              <label class="col-sm-3 control-label" for="querier">Querier</label>
              <div class="col-sm-5">
                <select class="form-control" id="querier" v-model="querierEnable">
                  <option value="0">Disable</option>  
                  <option value="1">Enable</option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-3 control-label" for="queriervlan">Querier-vlan</label>
              <div class="col-sm-5">
                   <input
                    type="text"
                    class="form-control"
                    id="vlan"
                    v-model="querierVlan"
                  />
              </div>
            </div>
            <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </div>
      <info-box :ibox="iBox"></info-box>
    </div>
</template>
<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "./../components/InfoBox.vue"
import { get, post } from "@/utils/http.js"
import DialogBox from "@/components/DialogBox"

export default {
  name: "igmpconfig",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  data() {
    return {
      igmpSnoopEnable:"",
      reportSuppression:"",
      routerPortEnable:"",
      querierEnable:"",
      querierVlan:"",
      iBox: {},
      isShowAddTable: false,
      igmpSnoopTable:{},
    }
  },
  created() {
    this.loadIgmpSnoopGlobal()
  },
  methods: {
    loadIgmpSnoopGlobal() {
      get("igmpSnoopGlobal")
        .then((res) => {
          this.igmpSnoopTable = res.data
          console.log(res.data)
        })
        .catch((err) => {
             console.log(err)
        })
    },

    /* 页面提交函数 */
    clkApply() {
      var postData={
        igmpSnoopEnable: Number(this.igmpSnoopEnable),
        reportSuppression: Number(this.reportSuppression),
        routerPortEnable: Number(this.routerPortEnable),
        querierEnable: Number(this.querierEnable),
        querierVlan : this.querierVlan
      }
      post("igmpSnoopGlobal", postData)
        .then((res) => {
          if (
            res.data.code === undefined ||
            (res.data.code === 0 && res.data.msg === undefined)
          )
            this.showAlertBox("info", "Info", "Config successful!")
          else
            this.showAlertBox(
              res.data.code === 0 ? "info" : "warn",
              "Message",
              res.data.msg !== undefined ? res.data.msg : "Unknown error!"
            )
          this.loadIgmpSnoopGlobal()
        })
        .catch((err) => {
          this.showAlertBox("critical", "Error", err)
        })

      this.clkCancel()
    },

    editSelectRow()
    {
        this.igmpSnoopEnable = this.igmpSnoopTable.data[0].igmpSnoopEnable == "enable" ? "1":"2"
        this.reportSuppression = this.igmpSnoopTable.data[0].reportSuppression == "enable" ? "1":"0"
        this.routerPortEnable = this.igmpSnoopTable.data[0].routerPortEnable == "enable" ? "1":"2"
        this.querierEnable = this.igmpSnoopTable.data[0].querierEnable == "disable" ? "0":"1"
        this.querierVlan = this.igmpSnoopTable.data[0].querierVlan
        this.isShowAddTable = true
    },

    /* 页面恢复函数 */
    clkCancel() {
      this.isShowAddTable = false
    },


   
    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>